import { createFileRoute } from "@tanstack/react-router"

import { PlaceholderPanel } from "@/components/shared/PlaceholderPanel"

export const Route = createFileRoute("/operations/calendar")({
  component: () => (
    <PlaceholderPanel
      title="Release Calendar"
      description="Weekly/monthly/quarterly releases, governance deadlines, template propagation dates, board/IC prep"
    />
  ),
})
